/**
 * @description This enum represents the different SCM enties available.
 * @author Per-Anders Karlsson
 */

export enum EntityTypes {
  RK = 'Registerkontroll',
  PROJECT = 'SUA-avtal',
  SUPPLIER = 'Organisation',
  PERSON = 'Person'
}

export namespace EntityTypes {

  /**
   * Returns an array of all values that the different types are set to
   * (i.e SuaStatusType.SENT will return the value 'Skickad').
   * @returns {Array<String>} Array of the type's string value.
   */
  export function getValues(): Array<String> {
    return [ 
      EntityTypes.RK,
      EntityTypes.PROJECT,
      EntityTypes.SUPPLIER,
      EntityTypes.PERSON,
    ]
  }
}